module.exports = __webpack_public_path__ + "img/small-myriad-genetics-logo-transparent.db2f9422.png";